import React from 'react';

const Logo = ({ light = false, size = 40 }) => (
  <span className={`cp-logo ${light ? 'cp-logo-light' : ''}`}>
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <defs>
        <linearGradient id="cpLg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#14c9a8" />
          <stop offset="1" stopColor="#f5b301" />
        </linearGradient>
      </defs>
      <rect x="2" y="8" width="44" height="32" rx="9" fill="url(#cpLg)" />
      <rect x="2" y="16" width="44" height="6" fill="#071a3d" opacity=".35" />
      <path d="M31 27a8 8 0 1 0 0 6" stroke="#fff" strokeWidth="3.4" fill="none" strokeLinecap="round" />
      <circle cx="35" cy="33" r="2.4" fill="#fff" />
    </svg>
    <span className="cp-logo-text">Credit<b>Plate</b></span>
  </span>
);

export default Logo;
